import {Field} from 'formik'

const PMSCheckBox = ({label, name,id}) => {
    return (
        <div className="form-check m-2">
            <Field type="checkbox" name={name} className={`form-check-input`} id={id}/>
            <label className="form-check-label" htmlFor={id}>{label}</label>
        </div>
    )
}

export default PMSCheckBox